<div class="content" #content>
    <ng-content></ng-content>
</div>
